/* eslint 'array-callback-return': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import '../../../../../../Assets/EnsembleStyles/Filter.css';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import AdditionalDeleteConfirmation from '../../_ModalsForms/AdditionalDeleteConfirmation';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import { DeleteEmployees } from '../../../../../../action/tenantAction';
import { GetZonesList } from '../../../../../../action/ZonesAction';
import AddEmployees from '../CreateTenant/Modal_Forms_Create/AddEmployee';


let TenantID = 0, EmployeeList = [];
let TenantUserID = 0, EmployeeDetails = [], IsEdit = false;
class ViewEmployee extends Component {
    componentWillMount() {
        TenantID = this.props.userID || localStorage.getItem('userID');
        this.props.GetZonesList();
    }
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            Deletemodal: false,
            error_msg: false,
            Tenant_zones: this.props.TenantZones_response,
            Tenant_Employees: this.props.Employees_response,
            sort:{
                column:'firstName',
                direction:[
                    {name:'firstName', direction:'asc', onclick:true},
                    {name:'employeeEmail', direction:'desc', onclick:false},
                    {name:'zoneName', direction:'desc', onclick:false},
                    {name:'allowTemperatureAdjustment', direction:'desc', onclick:false},
                ]
            },
            IsDefaultSort: true,
            IsChangesSaved: false,
        };
        this.toggle = this.toggle.bind(this);
        this.Deletetoggle = this.Deletetoggle.bind(this);
        this.deleteEmployees = this.deleteEmployees.bind(this);
        this.ViewEmployeeDetailslink = this.ViewEmployeeDetailslink.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            var modalClose =nextProps.ModalOpenCloseResponse.ModalOpenClose.modal_open;
            if(modalClose=="close"){
                this.setState({  modal: false, Tenant_Employees: nextProps.Employees_response, Tenant_zones: nextProps.TenantZones_response, IsChangesSaved: true});
            }else{
                this.setState({
                    Tenant_Employees: nextProps.Employees_response, Tenant_zones: nextProps.TenantZones_response
                });
            }
        }
    }

    ViewEmployeeDetailslink(TUserID) {
        TenantUserID = TUserID;
        IsEdit = true;
        EmployeeDetails = this.state.Tenant_Employees.filter(el => el.tenantUserId == TUserID)
        this.setState({ modal: true });
    }

    toggle() {
        TenantUserID = 0;
        EmployeeDetails = [];
        IsEdit = false;
        this.setState({
            modal: !this.state.modal
        });
    }

    Deletetoggle() {
        this.setState({
            Deletemodal: !this.state.Deletemodal
        });
    }
    deleteEmployees() {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('AvailableEmpRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }
    /* Delete Confirmation*/
    Delete = (someArg) => {
        var IsCheck = someArg.split(',')
        if (IsCheck[0] == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('AvailableEmpRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var Emp_id_to_be_deleted = {
                        "tenantUserId": checkboxes[i].id
                    }
                    Data.push(Emp_id_to_be_deleted);
                }
            }
            if (Data.length > 0) {
                this.setState({ error_msg: false });
                var IsFutReqDelete = document.getElementsByClassName(IsCheck[1]);
                this.props.DeleteEmployees(Data, TenantID, IsFutReqDelete[0].checked);
                this.Deletetoggle();
            }
        }
        else {
            this.Deletetoggle();
        }
    }

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.Tenant_Employees;
        var notequals = 0;

        if(data_from_state != null){
            const sortedData = this.state.Tenant_Employees.sort((a, b) => {
                const nameA = (column === "allowTemperatureAdjustment") ? !a[column] : (column === "zoneName") ? (a[column] !== null) ? a[column] : " " : a[column].toLowerCase();
                const nameB = (column === "allowTemperatureAdjustment") ? !b[column] : (column === "zoneName") ? (b[column] !== null) ? b[column] : " " : b[column].toLowerCase();
                if (nameA < nameB) {
                    notequals = 1;
                    return -1;
                }
                if (nameA > nameB) {
                    notequals = 1;
                    return 1;
                }
                if (nameA == nameB) {
                    return 0;
                }
                return 0;
            });
            if(selected[0].direction =='asc' && notequals == 1){
                sortedData.reverse();
            }
            
            SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
            SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);
            
            this.setState({
                Tenant_Employees: sortedData,
                sort: {
                    column,
                    direction:SortData,
                }
            });
        }    
    }

    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };

    render(Employees_response, getResponse, TenantZones_response,getLabels,UserCanEdit) {
        let Error_Message, Employees, ZoneList = [];

        let lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
        
        let label = this.props.getLabels;

        if (this.state.Tenant_Employees !== undefined && this.state.Tenant_Employees !== null && this.state.Tenant_Employees.length) {            
            this.state.Tenant_Employees.map(el => {
                if(!el.isDeleted){
                    var ZoneIds = el.zoneIds;
                    var ZoneNames = "";
                    if (this.props.getResponse != undefined && this.props.getResponse.ZonesList.length && ZoneIds != null) {
                        ZoneList = this.props.getResponse.ZonesList;
                        // ZoneList = ZoneList.filter(function (item) {
                        //     return ZoneIds.join(',').search(item.zoneId) !== -1
                        // });
                        ZoneList = ZoneList.filter((obj) => {
                            for (let i = 0, length = ZoneIds.length; i < length; i++) {
                            if (obj.zoneId === ZoneIds[i]) 
                                return true;
                            }
                        })
                        if (ZoneList != null) {
                            ZoneNames = ZoneList.map(xl => (xl.zoneName)).join(', ');                            
                        }
                        el.zoneName = ZoneNames;
                    }
                }                
            });
            if(this.state.IsDefaultSort){
                this.state.Tenant_Employees.sort((a,b)=>{
                    let nameA = a['firstName'].toLowerCase();
                    let nameB = b['firstName'].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });  
            }
            if(this.state.IsChangesSaved){
                this.state.Tenant_Employees.sort((a,b) => {
                    let nameA = (this.state.sort.column === "allowTemperatureAdjustment") ? !a[this.state.sort.column] : (this.state.sort.column === "zoneName") ? (a[this.state.sort.column] !== null) ? a[this.state.sort.column] : " " : a[this.state.sort.column].toLowerCase();
                    let nameB = (this.state.sort.column === "allowTemperatureAdjustment") ? !b[this.state.sort.column] : (this.state.sort.column === "zoneName") ? (b[this.state.sort.column] !== null) ? b[this.state.sort.column] : " " : b[this.state.sort.column].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });
                if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
                    this.state.Tenant_Employees.reverse();
                }
                this.setState({IsChangesSaved: false});
            }
            EmployeeList = this.state.Tenant_Employees.filter(el => !el.isDeleted);
            if(EmployeeList.length){  
                Employees = EmployeeList.map(el => {
                    return <tr>
                        <td style={{"width":"5%"}}><input type="checkbox" id={el.tenantUserId} className="AvailableEmpRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("AvailableEmpRows", "AvailEmps_header_Check_box"); }} /></td>
                        {
                            lUserCanEdit ? <td style={{"width":"25%",color: '#6890C6'}} onClick={() => { this.ViewEmployeeDetailslink(el.tenantUserId) }} className="link_cursor">{el.firstName}{" "}{el.lastName}</td> : 
                            <td style={{"width":"25%"}} className="link_cursor">{el.firstName}{" "}{el.lastName}</td>
                        }
                        
                        <td style={{"width":"20%"}}>{el.employeeEmail}</td>
                        <td style={{"width":"20%"}}>{el.zoneName}</td>
                        <td style={{"width":"30%"}}>{(el.zonesTemperatureAdjustment !== undefined && el.zonesTemperatureAdjustment !== null && el.zonesTemperatureAdjustment.filter(x => x.allowTemperatureAdjustment === true).length) ? "Allowed" : "Not Allowed"}</td>
                    </tr>
                })
            }
            else{
                Employees = <tr><td colSpan="5">{label['NoRecords.Text']}</td></tr>
            }
        }else {
                Employees = <tr><td colSpan="5">{label['NoRecords.Text']}</td></tr>
            }
        // Error Message
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  Error: Select one or more tenant employees to perform this action.</p> : Error_Message = " ";

        return (
            <div className="main_container">
                {Error_Message}

                <div className="buttons_container">
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.deleteEmployees}>{label['ManageHolidays.Delete.Text'] !== undefined ? label['ManageHolidays.Delete.Text'] : "Delete"}</Button>
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.toggle} >{label['CreateTenant.CreateTenantUser.Text']}</Button>
                </div>

                <div className="table_container">
                    <Table striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th style={{"width":"5%"}}><input type="checkbox" className="AvailEmps_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("AvailableEmpRows", "AvailEmps_header_Check_box"); }} /></th>
                                <th style={{"width":"25%"}} onClick={this.onSort('firstName')}>{label['DefaultTemplate.Occupant.Text']}<span className={this.setArrow('firstName')}></span></th>
                                <th style={{"width":"20%"}} onClick={this.onSort('employeeEmail')}>{label['AddEditTenantUser.TenantOccupantEmail.Text']}<span className={this.setArrow('employeeEmail')}></span></th>
                                <th style={{"width":"20%"}} onClick={this.onSort('zoneName')}>{label['AddEditTenantUser.column.AfterHoursPlaces.Text']}<span className={this.setArrow('zoneName')}></span></th>
                                <th style={{"width":"30%"}} onClick={this.onSort('allowTemperatureAdjustment')}>{label['AddEditTenantUser.column.TemperatureSetting.Text']}<span className={this.setArrow('allowTemperatureAdjustment')}></span></th>
                            </tr>
                            {Employees}
                        </tbody>
                    </Table>
                </div>

                <Modal isOpen={this.state.Deletemodal} Deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <AdditionalDeleteConfirmation parentToChildData={["Delete Employee", "You are about to delete an employee from the tenant. Check the box if you want to delete all future after hours requests that the employee made.", "Delete employee's future after hours requests"]} Delete={this.Delete} />
                </Modal>
                <Modal isOpen={this.state.modal} zIndex = "2147483646" style={{width:'auto'}}>
                    <AddEmployees parentToChildData={[TenantUserID, TenantID, this.state.Tenant_zones, EmployeeDetails, IsEdit]} />
                </Modal>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        getResponse: state.zonesRootReducer,
        Employees_response: state.ViewtenantsRootReducer.Employees,
        TenantZones_response: state.ViewtenantsRootReducer.TenantZones,
        ModalOpenCloseResponse: state.ModalOpenCloseRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetZonesList: () => dispatch(GetZonesList()),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        DeleteEmployees: (data, id, IsDeleteFutReq) => dispatch(DeleteEmployees(data, id, IsDeleteFutReq))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployee);





